import React from "react";
import AppSelect from "@/components/shared/AppSelect";
import "./SalidaFields.css";

export const salidaInicial = { motivo: "", modalidad: "planta", idplantaDestino: "", destinoManual: "" };

export const validarSalida = (value) => {
  const errors = {};
  if (!value.motivo.trim() || [...value.motivo.trim()].length > 255) errors.motivo = "Indica un motivo de hasta 255 caracteres.";
  if (value.modalidad === "manual") {
    if (!value.destinoManual.trim() || [...value.destinoManual.trim()].length > 255) errors.destinoManual = "Indica un destino de hasta 255 caracteres.";
  } else if (!value.idplantaDestino) errors.idplantaDestino = "Selecciona una planta de destino.";
  return errors;
};

export const salidaPayload = (value) => ({
  motivo: value.motivo.trim(),
  idplantaDestino: value.modalidad === "planta" ? Number(value.idplantaDestino) : null,
  destinoManual: value.modalidad === "manual" ? value.destinoManual.trim() : null,
});

export default function SalidaFields({ value, onChange, plantas, plantasError, errors = {}, disabled, prefix }) {
  const update = (key, val) => onChange({ ...value, [key]: val });
  const errorProps = (key) => ({ id: `${prefix}-${key}`, "aria-invalid": !!errors[key], "aria-describedby": errors[key] ? `${prefix}-${key}-error` : undefined });
  return <div className="salida-fields">
    <label htmlFor={`${prefix}-motivo`}>Motivo (obligatorio)</label>
    <input {...errorProps("motivo")} value={value.motivo} maxLength={255} disabled={disabled} onChange={e => update("motivo", e.target.value)} />
    {errors.motivo && <p id={`${prefix}-motivo-error`} role="alert">{errors.motivo}</p>}
    <label htmlFor={`${prefix}-modalidad`}>Tipo de destino</label>
    <select id={`${prefix}-modalidad`} value={value.modalidad} disabled={disabled} onChange={e => onChange({ ...value, modalidad: e.target.value, idplantaDestino: "", destinoManual: "" })}>
      <option value="planta">Planta existente</option><option value="manual">Destino manual</option>
    </select>
    <label htmlFor={`${prefix}-${value.modalidad === "manual" ? "destinoManual" : "idplantaDestino"}`}>Destino (obligatorio)</label>
    {value.modalidad === "manual" ? <input {...errorProps("destinoManual")} maxLength={255} value={value.destinoManual} disabled={disabled} onChange={e => update("destinoManual", e.target.value)} /> :
      <AppSelect {...errorProps("idplantaDestino")} name="idplantaDestino" options={plantas.map(p => ({ value: p.idplanta, label: p.nombreplanta }))} value={value.idplantaDestino} onChange={val => update("idplantaDestino", val)} isDisabled={disabled} isClearable variant="modal" menuPortalTarget={document.body} placeholder="Selecciona una planta" />}
    {errors.destinoManual && value.modalidad === "manual" && <p id={`${prefix}-destinoManual-error`} role="alert">{errors.destinoManual}</p>}
    {errors.idplantaDestino && value.modalidad === "planta" && <p id={`${prefix}-idplantaDestino-error`} role="alert">{errors.idplantaDestino}</p>}
    {plantasError && <p role="status">No se pudieron cargar las plantas. Puedes usar un destino manual.</p>}
  </div>;
}
